export const tokenUrl = process.env.REACT_APP_API_AUTH_TARGET + "generatetoken?type=ad";
export const quesParentUrl = process.env.REACT_APP_API_TARGET + "questions";
export const quesChildUrl =
  process.env.REACT_APP_API_TARGET + "questions/parent-id";
export const submitUrl = process.env.REACT_APP_API_TARGET + "submit-answers";
export const getQuestionRequestParams =
  process.env.REACT_APP_API_TARGET + "questions/store-code";

